import { yXmlFragmentToProsemirrorJSON } from 'y-prosemirror';
export const ydocToJSON = (ydoc) => {
    if (!ydoc) {
        return null;
    }
    try {
        const fragmentNames = ['default', 'prosemirror', 'content', ''];
        let yxmlFragment = null;
        for (const name of fragmentNames) {
            const fragment = ydoc.getXmlFragment(name);
            if (fragment.length > 0) {
                yxmlFragment = fragment;
                break;
            }
        }
        if (!yxmlFragment || yxmlFragment.length === 0) {
            return null;
        }
        const json = yXmlFragmentToProsemirrorJSON(yxmlFragment);
        return json;
    }
    catch (error) {
        console.error('Error converting Y.Doc to JSON:', error);
        return null;
    }
};
//# sourceMappingURL=ydoc-to-json.js.map